import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import {
    MutationGetListeElementsAssociesAlbumArgs,
    MutationSupprimerAlbumEtFichiersArgs
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { SharedFolderDeleteFolderAction, SharedFolderGetRelatedElementsAction } from 'src/app/_shared/stores/folder/folder.actions';
import { Injectable } from '@angular/core';
import { GraphqlService } from 'src/app/_core/services/graphql.service';

export class SharedFolderStateModel {

    loading = false;

    hasRelatedElements = false;

}

@Injectable()
@State<SharedFolderStateModel>({
    name: 'sharedFolder',
    defaults: new SharedFolderStateModel()
})
export class SharedFolderState {

    constructor(private graphqlService: GraphqlService) {
    }

    // <editor-fold defaultstate="collapsed" desc="Selectors">

    @Selector()
    static loading(state: SharedFolderStateModel): boolean {
        return state.loading;
    }

    @Selector()
    static hasRelatedElements(state: SharedFolderStateModel): boolean {
        return state.hasRelatedElements;
    }

    // </editor-fold>

    // <editor-fold defaultstate="collapsed" desc="Actions">

    @Action(SharedFolderGetRelatedElementsAction)
    getRelatedElements(
        {patchState}: StateContext<SharedFolderStateModel>,
        {folderId}: SharedFolderGetRelatedElementsAction
    ) {
        patchState({loading: true});

        return this.graphqlService.mutateOne<'GetListeElementsAssociesAlbum', MutationGetListeElementsAssociesAlbumArgs>({
            mutation: gql`
                mutation GetListeElementsAssociesAlbum($contexte: ContextInfosInput, $idAlbum: Float) {
                    GetListeElementsAssociesAlbum(contexte: $contexte, idAlbum: $idAlbum) {
                        ElementAssocieDocModel {
                            Libelle
                            NomDocument
                        }
                    }
                }
            `,
            variables: {idAlbum: folderId}
        })
        .pipe(
            tap((GetListeElementsAssociesAlbum) => {
                patchState({
                    hasRelatedElements: (GetListeElementsAssociesAlbum?.ElementAssocieDocModel || []).length > 0,
                    loading: false
                });
            }),
            catchError(err => {
                patchState({loading: false});
                return throwError(err);
            }),
        );
    }

    @Action(SharedFolderDeleteFolderAction)
    deleteFolder(
        {patchState}: StateContext<SharedFolderStateModel>,
        {data: {folderId, shouldDeleteRelatedFiles}}: SharedFolderDeleteFolderAction
    ) {
        patchState({loading: true});

        return this.graphqlService.mutateOne<'SupprimerAlbumEtFichiers', MutationSupprimerAlbumEtFichiersArgs>({
            mutation: gql`
                mutation SupprimerAlbumEtFichiers($contexte: ContextInfosInput, $idAlbum: Int, $withUsedFiles: Boolean) {
                    SupprimerAlbumEtFichiers(contexte: $contexte, idAlbum: $idAlbum, withUsedFiles: $withUsedFiles)
                }
            `,
            variables: {idAlbum: folderId, withUsedFiles: shouldDeleteRelatedFiles}
        })
        .pipe(
            tap(() => patchState({loading: false})),
            catchError(err => {
                patchState({loading: false});
                return throwError(err);
            }),
        );
    }

    // </editor-fold>

}
